import React, {Component} from 'react';
import Home from './components/Home';
import ProductDetail from './components/ProductDetail';
import About from './components/About';
import Cart from './components/Cart';
import InputNav from './components/InputNav';
import Icon from './components/Icon';
import {Switch, Route, BrowserRouter as Router, Link} from 'react-router-dom';
import SearchResults from './components/SearchResults';
import CollectionNav from './components/CollectionNav';
import PropTypes from 'prop-types';
import Header from './components/Header';
import Footer from './components/Footer';
 
import {
  Motion,
  StaggerdMotion,
  spring,
  translateX,
  TransitionMotion,
} from 'react-motion';
import {Row, Col} from 'reactstrap';
import Loader from 'react-loader';

import {Navbar, NavbarBrand, Nav, NavItem} from 'reactstrap';
//https://medium.com/react-native-training/react-animations-in-depth-433e2b3f0e8e
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCartOpen: false,
      isMenuOpen: false,
      checkout: {lineItems: []},
      products: [],
      shop: {},
      searchValue: '',
      collections: [],
      customStyle: {},
      cartItemCount: '',
      firstLoad: true,
    };
  }

  componentDidUpdate() {
    console.log("Prerender ready set to true")
    window.prerenderReady = true;
  }

  componentDidMount() {
    if (this.props.body_style == 'html') {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.innerHTML = this.findShopifyBuyScript(JSON.parse(this.props.body_html));
      document.body.appendChild(s);
    }
  }

  /* Find shopify script to run assuming shopify script is between CDATA and ]]*/
  findShopifyBuyScript(script) {
    let CDATA_idx = script.search('CDATA');
    let end_idx = script.search(']]');
    return script.substr(CDATA_idx + 8, end_idx - (CDATA_idx + 10));
  }

  componentWillMount() {
    //Don't grab from API if testing
    if (this.props.debug || !this.props.client) {
      return;
    }

    this.grabCart();
    this.props.client.checkout
      .fetch(localStorage.getItem('cartId'))
      .then(res => {
        this.setState({
          checkout: res,
          cartItemCount: this.countTotalItems(res.lineItems),
        });
      })
      .catch(err => {
        localStorage.clear();
        this.grabCart();
      });
    //TODO:
    this.grabCollections();
    this.props.client.collection.fetchAll().then(res => {
      this.props.client.fetchNextPage(res).then(r => {
        console.log(r);
      });
    });
  }

  countTotalItems = (items) => {
    var count = 0;
    items.forEach(item => {
      count += item.quantity;
    });
    return count;
  }

  grabCollections = () => {
    this.setState({collections: []});
    var inactiveCollections = [];
    //Create async calls
    function requestAsync(client, collectionBase64, collection) {
      return new Promise(function(resolve, reject) {
        client.collection
          .fetch(collectionBase64)
          .then(res => {
            res['slug'] = collection['slug'];
            res['display_name'] = collection['display_name'];
            res['sort_order'] = collection['sort_order'];
            res['shopify_collection_id'] = collection['shopify_collection_id'];
            return resolve(res);
          })
          .catch(err => {
            console.log(err);
            return reject(err);
          });
      });
    }

    var a = [];
    //For every collection, grab details about them from Shopify
    for (var key in this.props.collections) {
      let collection = this.props.collections[key];
      let collection_id = collection['shopify_collection_id'];
      if (!collection_id) {
        inactiveCollections.push(collection);
        continue;
      }
      //Change collection ID to base64
      var collectionBase64 = btoa(
        'gid://shopify/Collection/' +
          collection['shopify_collection_id'].toString(),
      );
      a.push(requestAsync(this.props.client, collectionBase64, collection));
    }

    Promise.all(a).then(
      function(allData) {
        this.setState({
          collections: allData.concat(inactiveCollections),
        });
      }.bind(this),
    );
  }

  grabCart = () => {
    //If cartId already exists then don't create a new cart
    if (localStorage.getItem('cartId') === null) {
      this.props.client.checkout.create({}).then(res => {
        this.setState({
          checkout: res,
          cartItemCount: this.countTotalItems(res.lineItems),
        });

        localStorage.setItem('cartId', res.id);
      });
    } else {
      //Couldn't find proper method to determine if user purchased items in the cart
      //Probably because we use window.open to handle checkout (pass responsibility to Shopify)
      //The code below tries modifying the cart and if there is an error we can assume user has already purchased
      //Items from the cart else the customAttributes would have been added
      try {
        const input = {
          customAttributes: [{key: 'DummyKey', value: 'TestIfCheckoutIsValid'}],
        };

        this.props.client.checkout
          .updateAttributes(localStorage.getItem('cartId'), input)
          .then(checkout => {
            // Do something with the updated checkout
          });
      } catch (err) {
        localStorage.clear();
        this.grabCart();
      }
    }
  }

  addVariantToCart = (variantId, quantity) => {
    this.setState({
      isCartOpen: true,
    });
    const lineItemsToAdd = [{variantId, quantity: parseInt(quantity, 10)}];
    const checkoutId = this.state.checkout.id;
    return this.props.client.checkout
      .addLineItems(checkoutId, lineItemsToAdd)
      .then(res => {
        this.setState({
          checkout: res,
          cartItemCount: this.countTotalItems(res.lineItems),
        });
      });
  }

  updateQuantityInCart = (lineItemId, quantity) => {
    const checkoutId = this.state.checkout.id;
    const lineItemsToUpdate = [
      {id: lineItemId, quantity: parseInt(quantity, 10)},
    ];

    return this.props.client.checkout
      .updateLineItems(checkoutId, lineItemsToUpdate)
      .then(res => {
        this.setState({
          checkout: res,
          cartItemCount: this.countTotalItems(res.lineItems),
        });
      });
  }

  removeLineItemInCart = (lineItemId) => {
    const checkoutId = this.state.checkout.id;

    return this.props.client.checkout
      .removeLineItems(checkoutId, [lineItemId])
      .then(res => {
        this.setState({
          checkout: res,
          cartItemCount: this.countTotalItems(res.lineItems),
        });
      });
  }

  updateSearchInput = (e, history) => {
    //When user presses the enter key
    if (e.key === 'Enter') {
      this.setState({
        searchValue: e.target.value,
      });
      history.push('/search/' + e.target.value);
    } else if (e.type === 'click') {
      //If user clicked on search button
      history.push('/search/' + this.state.searchValue);
    }
  }
 
  handleCartClose = () => {
    this.setState({
      isCartOpen: false,
    });
  }

  handleMenuClose = () => {
    this.setState({
      isMenuOpen: false,
    });
  }

  handleCartOpen = () => {
    this.setState({
      isCartOpen: true,
    });
  }

  handleMenuOpen = () => {
    this.setState({
      isMenuOpen: true,
    });
  }

  updateFirstLoad = () => {
    this.setState({
      firstLoad: false,
    });
  }

  render() {
    let switchRoute = (
      <Switch>
        {this.props.body_style === 'default' && (
          <Route
            exact
            path="/"
            render={props => (
              <Home
                {...props}
                body_style={this.props.body_style}
                addVariantToCart={this.addVariantToCart}
                collections={this.state.collections}
                client={this.props.client}
                style={this.props.customStyle}
                firstLoad={this.state.firstLoad}
                updateFirstLoad={this.updateFirstLoad}
              />
            )}
          />
        )}
        {this.props.body_style === 'shopify_product' && (
          <Route
            path="/"
            render={props => (
              <ProductDetail
                {...props}
                body_style={this.props.body_style}
                client={this.props.client}
                collections={this.state.collections}
                addVariantToCart={this.addVariantToCart}
                style={this.props.customStyle}
              />
            )}
          />
        )}
        {this.props.body_style === 'html' && (
          <Route
            path="/"
            render={props => (
              <div
                dangerouslySetInnerHTML={{
                  __html: JSON.parse(this.props.body_html),
                }}
              />
            )}
          />
        )}
        <Route
          exact
          path="/:handle"
          render={props => (
            <Home
              {...props}
              addVariantToCart={this.addVariantToCart}
              collections={this.state.collections}
              client={this.props.client}
              style={this.props.customStyle}
              firstLoad={this.state.firstLoad}
              updateFirstLoad={this.updateFirstLoad}
            />
          )}
        />
        <Route
          path="/collections/:handle"
          render={props => (
            <Home
              {...props}
              addVariantToCart={this.addVariantToCart}
              collections={this.state.collections}
              client={this.props.client}
              style={this.props.customStyle}
              collection={true}
              firstLoad={this.state.firstLoad}
              updateFirstLoad={this.updateFirstLoad}
            />
          )}
        />
        {this.props.body_style === 'default' && (
          <Route
            path="/products/:handle"
            render={props => (
              <ProductDetail
                {...props}
                body_style={this.props.body_style}
                client={this.props.client}
                collections={this.state.collections}
                addVariantToCart={this.addVariantToCart}
                style={this.props.customStyle}
              />
            )}
          />
        )}
        <Route
          path="/search/:handle"
          render={props => (
            <SearchResults
              {...props}
              style={this.props.customStyle}
              grabCollections={this.grabCollections}
              client={this.props.client}
              addVariantToCart={this.addVariantToCart}
              search={this.state.searchValue}
              collections={this.state.collections}
            />
          )}
        />
        <Route
          path="/about"
          render={props => <About {...props} style={this.props.customStyle} />}
        />
        <Route component={() => (window.location = '/')} />
      </Switch>
    );
    const willLeave = () => ({
      borderWidth: 0,
    });

    var mobileCollectionNav = <div />;

    if (this.state.isMenuOpen) {
      mobileCollectionNav = (
        <CollectionNav
          isMenuOpen={this.state.isMenuOpen}
          collections={this.props.collections}
          style={this.props.customStyle}
          handleMenuClose={this.handleMenuClose}
        />
      );
    }

    // Show skeleton on page load
    var showSkeleton = <div />;

    if (!this.state.collections.length) {
      showSkeleton = <ul class="Collection Collection__desktop" />;
    } else {
      showSkeleton = (
        <CollectionNav
          collections={this.props.collections}
          style={this.props.customStyle}
        />
      );
    }

    var showCollection = <Row className="Product-wrapper" />;

    //If only Homepage collection then don't show collection sidenav
    if (
      this.state.collections.length === 1 ||
      this.props.body_style == 'html'
    ) {
      showCollection = (
        <Row className="Product-wrapper">
          <Col lg="12">{switchRoute}</Col>
        </Row>
      );
    } else {
      showCollection = (
        <Row className="Product-wrapper">
          <Col xs="12" lg="3">
            {showSkeleton}
          </Col>
          <Col xs="12" lg="9">
            {switchRoute}
          </Col>
        </Row>
      );
    }

    return (
      <Router>
        <div className="App" style={this.props.customStyle.bodyBackgroundColor}>
          <div id="header_container">
            <Header
              customStyle={this.props.customStyle}
              isMenuOpen={this.state.isMenuOpen}
              collections={this.state.collections}
              isCartOpen={this.state.isCartOpen}
              searchClicked={this.updateSearchInput}
              menuClicked={this.handleMenuOpen}
              cartClicked={this.handleCartOpen}
            />
            <Row id="bottom-header" style={this.props.customStyle.headerBreak}>
              <div className="container">
                <Row>
                  <Col>
                    <h5 id="header_break_text">
                      {this.props.header_break_text}
                    </h5>
                  </Col>
                  <Col>
                    <h5 id="help">
                      <strong>
                        <a
                          href="https://partners.annarbortees.com/pages/help-faqs-support"
                          style={{
                            color: this.props.customStyle.headerBreakColor,
                          }}>
                          {' '}
                          HELP{' '}
                        </a>
                      </strong>
                    </h5>
                  </Col>
                </Row>
              </div>
            </Row>
          </div>

          <div className="container-fluid body-row">
            <div className="row body-row">
              <div className="container">{showCollection}</div>
            </div>
          </div>
          {!this.state.isCartOpen && (
            <div className="App__view-cart-wrapper-mobile">
              <div />
              <div
                style={this.props.customStyle.addToCartButton}
                onClick={() => this.setState({isCartOpen: true})}>
                <p className="Cart__item-count">{this.state.cartItemCount}</p>
                <Icon.FaCartIcon />
              </div>
            </div>
          )}
          <Cart
            checkout={this.state.checkout}
            isCartOpen={this.state.isCartOpen}
            handleCartClose={this.handleCartClose}
            updateQuantityInCart={this.updateQuantityInCart}
            removeLineItemInCart={this.removeLineItemInCart}
            style={this.props.customStyle}
          />
          {mobileCollectionNav}
          {this.props.customStyle.footer &&
          this.props.customStyle.footer.footer_style == 'html' ? (
            <div
              className="footer-html"
              dangerouslySetInnerHTML={{
                __html: this.props.customStyle.footer.footer_html,
              }}
            />
          ) : (
            <Footer customStyle={this.props.customStyle} />
          )}
        </div>
      </Router>
    );
  }
}
 
export default App;



// WEBPACK FOOTER //
// ./src/App.js